import SuperAdminBrands from './SuperAdminBrands';

export default SuperAdminBrands;
